/** Swedish & Norwegian widget embed strings (Danish in widgetLabels.js). */

export const sv = {
  live: 'LIVE',
  upcoming: 'Kommande',
  fullTime: 'Slut',
  vs: 'mot',
  noMatches: 'Inga matcher tillgängliga.',
  noData: 'Ingen data tillgänglig.',
  goals: 'Mål',
  assists: 'Assist',
  appearances: 'Matcher',
  minutes: 'Min',
  played: 'S',
  won: 'V',
  drawn: 'O',
  lost: 'F',
  points: 'P',
  form: 'Form',
  position: 'Pos',
  player: 'Spelare',
  team: 'Lag',
  coach: 'Tränare',
  venue: 'Arena',
  referee: 'Domare',
  attendance: 'Publik',
  halfTime: 'Halvtid',
  overall: 'TOTALT',
  all: 'Alla',
  home: 'Hemma',
  away: 'Borta',
  teamList: 'Laglista',
  teamProfile: 'Lagprofil',
  playerList: 'Spelarlista',
  playerProfile: 'Spelarprofil',
  status: 'Status',
  matchCoaches: 'Matchtränare',
  headCoach: 'Huvudtränare',
  nationality: 'Nationalitet',
  age: 'Ålder',
  appointed: 'Tränare sedan',
  formation: 'Formation',
  opponent: 'Motståndare',
  touchline: 'Bänk',
  homeVenue: 'Hemmaarena',
  goalsFor: 'GM',
  goalsAgainst: 'IM',
  goalDifference: 'MS',
  squadPlayers: 'spelare i truppen',
  fullSquad: 'Hela truppen',
  selectTeamSquad: 'Välj ett lag',
  selectTeamSquadHint:
    'Använd lag-menyn ovanför förhandsgranskningen för att ladda alla spelare för klubben.',
  noSquadData: 'Ingen truppdata för detta lag i flödet.',
  captain: 'Kapten',
  injured: 'Skadad',
  rating: 'Betyg',
  cards: 'Kort',
};

export const no = {
  live: 'LIVE',
  upcoming: 'Kommende',
  fullTime: 'Slutt',
  vs: 'mot',
  noMatches: 'Ingen kamper tilgjengelig.',
  noData: 'Ingen data tilgjengelig.',
  goals: 'Mål',
  assists: 'Assist',
  appearances: 'Kamper',
  minutes: 'Min',
  played: 'K',
  won: 'V',
  drawn: 'U',
  lost: 'T',
  points: 'P',
  form: 'Form',
  position: 'Pos',
  player: 'Spiller',
  team: 'Lag',
  coach: 'Trener',
  venue: 'Arena',
  referee: 'Dommer',
  attendance: 'Tilskuere',
  halfTime: 'Pause',
  overall: 'SAMLET',
  all: 'Alle',
  home: 'Hjemme',
  away: 'Borte',
  teamList: 'Lagliste',
  teamProfile: 'Lagprofil',
  playerList: 'Spillerliste',
  playerProfile: 'Spillerprofil',
  status: 'Status',
  matchCoaches: 'Kampens trenere',
  headCoach: 'Hovedtrener',
  nationality: 'Nasjonalitet',
  age: 'Alder',
  appointed: 'Trener siden',
  formation: 'Formasjon',
  opponent: 'Motstander',
  touchline: 'Benk',
  homeVenue: 'Hjemmebane',
  goalsFor: 'MF',
  goalsAgainst: 'MI',
  goalDifference: 'MD',
  squadPlayers: 'spillere i troppen',
  fullSquad: 'Full tropp',
  selectTeamSquad: 'Velg et lag',
  selectTeamSquadHint:
    'Bruk lag-menyen over forhåndsvisningen for å laste alle spillere for klubben.',
  noSquadData: 'Ingen troppdata for dette laget i feeden.',
  captain: 'Kaptein',
  injured: 'Skadet',
  rating: 'Vurdering',
  cards: 'Kort',
};
